var state = {
    isLogin:0,//初始时候给一个 isLogin=0 表示用户未登录
    showLoading: false,
    userInfo: {},
    city: '全国',
    appid: '',
    publicPath:'',
    host:'', // 域名
    color:'', //主题色
    env:'', //测试or正式
    title: '',
    linkTitle: '',
    linkRouter: '',
    agency: '', //主管部门
    stylePath: 'https://style.81lianpin.com/',
    provinceName: '',
    zphUrl: '',
    companyName: '',
    homeID:'', //首页id
    moduleStatus: {
        assessIconHide: 0,
        bannerHide: 0,
        courseIconHide: 0,
        hotRecruitHide: 0,
        hotTrainHide: 0,
        infoIconHide: 0,
        jobCategoryHide: 0,
        jobFairIconHide: 0,
        jobGuideHide: 0,
        myDeliverHide: 0,
        myInfoHide: 0,
        myResumeHide: 0,
        myTrainEnrollHide: 0,
        newestNewsHide: 0,
        newsIconHide: 0,
        policyIconHide: 0,
        recruitmentIconHide: 0,
        managerHide: 0 //我是管理人员 是否隐藏 0：否  1：是
    },
    accountBalance: {}, //账户余额

    // ifRefresh: false //是否刷新职位列表 
}
export default state


// WEBPACK FOOTER //
// ./src/store/state.js